import React from 'react';
import imageNotFound from '@public/image-not-available.jpg';

const CustomImg = (props) => (
  <img
    {...props}
    alt={props.alt || ''}
    onError={(e) => {
      e.target.onerror = null
      e.target.src = imageNotFound
    }} />
)

export default CustomImg
